import { render, staticRenderFns } from "./ConversationWorkflowSidebar.vue?vue&type=template&id=1c967000&scoped=true"
import script from "./ConversationWorkflowSidebar.vue?vue&type=script&lang=js"
export * from "./ConversationWorkflowSidebar.vue?vue&type=script&lang=js"
import style0 from "./ConversationWorkflowSidebar.vue?vue&type=style&index=0&id=1c967000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c967000",
  null
  
)

export default component.exports